import { render, staticRenderFns } from "./Aktivnosti.vue?vue&type=template&id=f6799992&scoped=true&"
import script from "./Aktivnosti.vue?vue&type=script&lang=ts&"
export * from "./Aktivnosti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6799992",
  null
  
)

export default component.exports